// import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";
// import { useEffect } from "react";

const PrivateRoute = ({ Component }: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [cookies, setCookies] = useCookies(["redirect"]);
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj && JSON.parse(userObj);
  // const location = useLocation();

  // useEffect(() => {
  //   if (!userDetail?.id) {
  //     setCookies("redirect", location.pathname + location.search);
  //   }
  // }, [setCookies, location]);

  if (!!userDetail?.id) {
    return <Component />;
  }

  return <Navigate to="/" />;
};

export default PrivateRoute;
